/**
 * Keytips (Alt shortcut chain) state — Faz 3.11, the TS counterpart of the
 * OCS keytips module. `start()` arms the badge overlay; each resolved step
 * drills one level deeper (tabs -> groups -> items) and Escape / Alt-again
 * cancels from anywhere.
 */

import { create } from 'zustand';

export type KeytipLevel = 'tabs' | 'groups' | 'items';

interface KeytipsState {
    active: boolean;
    level: KeytipLevel;
    /** Tab selected in the `groups` level. */
    tabKey: string | null;
    /** Group selected in the `items` level. */
    groupKey: string | null;
    start: () => void;
    cancel: () => void;
    selectTab: (tabKey: string) => void;
    selectGroup: (groupKey: string) => void;
}

export const useKeytipsStore = create<KeytipsState>((set) => ({
    active: false,
    level: 'tabs',
    tabKey: null,
    groupKey: null,
    start: () => set({ active: true, level: 'tabs', tabKey: null, groupKey: null }),
    cancel: () => set({ active: false, level: 'tabs', tabKey: null, groupKey: null }),
    selectTab: (tabKey) => set({ level: 'groups', tabKey }),
    selectGroup: (groupKey) => set({ level: 'items', groupKey }),
}));
